import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/google/session", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !NO_RETRY.some((p) => orig.url.includes(p))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const posterUrl = (path, size = "w500") => (path ? `https://image.tmdb.org/t/p/${size}${path}` : null);
